import { TrophyIcon } from "../../assets/svg";
import React from "react";

type TrophyProgressProps = {
  /** Percentage 0–100 */
  value: number;
  size?: number;
  color?: string; // Tailwind color e.g. 'text-yellow-500'
  trackColor?: string; // Tailwind color for background ring
};

const TrophyProgress: React.FC<TrophyProgressProps> = ({
  value,
  size = 40,
  color = "text-white",
  trackColor = "text-gray-300",
}) => {
  const radius = (size - 8) / 2; // 8 = stroke width
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;

  return (
    <div
      className={`relative inline-flex items-center justify-center ${color}`}
      style={{ width: size, height: size }}
    >
      {/* SVG circular progress bar */}
      <svg
        className="transform -rotate-90"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle */}
        <circle
          className={`${trackColor}`}
          stroke="currentColor"
          strokeWidth="5"
          opacity={0.2}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
        />

        {/* Foreground progress */}
        <circle
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{
            transition: "stroke-dashoffset 400ms ease",
          }}
        />
      </svg>

      {/* Center trophy icon */}
      {/* <Trophy
        className="absolute"
        size={size / 2.5}
        strokeWidth={1.5}
      /> */}
      <div className="absolute"><TrophyIcon /></div>

      {/* Optional percentage label */}
      {/* <span className="absolute bottom-0 text-xs font-semibold text-gray-600">
        {Math.round(value)}%
      </span> */}
    </div>
  );
};

export default TrophyProgress;
